import { render, staticRenderFns } from "./ApmsRegContractSettlementBusinessDetail.vue?vue&type=template&id=38a1931d&scoped=true&"
import script from "./ApmsRegContractSettlementBusinessDetail.vue?vue&type=script&lang=js&"
export * from "./ApmsRegContractSettlementBusinessDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a1931d",
  null
  
)

export default component.exports